// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"70e13ee6","66":"b6196454","348":"32cdbd00","501":"b99d46e7","905":"ea7ef21a"}[chunkId] + ".chunk.js";
};